// extracted by mini-css-extract-plugin
export default {"expertsWrapper":"EventExpertsSection_expertsWrapper__iQTta","expertsWrapper__title":"EventExpertsSection_expertsWrapper__title__UX-M5"};